import {Injectable} from '@angular/core';
import { Http, Headers, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class HttpClient {

  constructor(private http: Http, private authService: AuthService, private router: Router) {
    
  }

  createAuthorizationHeader() {
    let headers = new Headers({ 'Authorization': 'Bearer ' + this.authService.token }); 
    let options = new RequestOptions({ headers: headers });   
    return options;
  }

  get(url, isFile?: boolean) {        
    var options = this.createAuthorizationHeader();
    if(isFile){
      options.headers.append('Content-Type', 'application/json');      
      options.headers.append('Accept', 'application/json');
      options.responseType = ResponseContentType.Blob;      
    }
    

    return this.intercept(this.http.get(environment.API_ENDPOINT + url, options));
  }

  post(url, data) {    
    

    var options = this.createAuthorizationHeader();
    return this.intercept(this.http.post(environment.API_ENDPOINT + url, data, options));
  }
   
  postWithFile (url: string, postData: any, fileData: any) {                  
    
      let formData:FormData = new FormData();
          
      if(postData !=="" && postData !== undefined && postData !==null){
        for (var property in postData) {
            if (postData.hasOwnProperty(property)) {
                formData.append(property, postData[property]);
            }
        }
      }
            
      formData.append(fileData.name, fileData.file, fileData.file.name);
      var options = this.createAuthorizationHeader();
      
      //options.headers.append('Content-Type', 'multipart/form-data');
      //options.headers.append('Accept', 'application/json');
      
      

      return this.intercept(this.http.post(environment.API_ENDPOINT + url, formData, options));        
  }

  postWithFiles (url: string, postData: any, fileData: Array<any>) {                  
    
      let formData:FormData = new FormData();
          
      if(postData !=="" && postData !== undefined && postData !==null){
        for (var property in postData) {
            if (postData.hasOwnProperty(property)) {
                formData.append(property, postData[property]);
            }
        }
      }
            debugger;
      fileData.forEach(element => {
        formData.append(element.name, element.file, element.file.name);  
      });
      
      var options = this.createAuthorizationHeader();
      
      //options.headers.append('Content-Type', 'multipart/form-data');
      //options.headers.append('Accept', 'application/json');
      
      

      return this.intercept(this.http.post(environment.API_ENDPOINT + url, formData, options));        
  }


  put(url, data) {    
    var options = this.createAuthorizationHeader();
    return this.intercept(this.http.put(environment.API_ENDPOINT + url, data, options));
  }

  delete(url) {
    var options = this.createAuthorizationHeader();
    return this.intercept(this.http.delete(environment.API_ENDPOINT + url, options));
  }

  intercept(observable: Observable<Response>): Observable<Response> {    
        return observable.catch((err, source) => {          
            if (err.status  == 401) {
                this.authService.logout();
                this.router.navigate(['/login']);
                return Observable.empty();
            } else {
                return Observable.throw(err);
            }
        });
  } 
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/shared/http-client.ts